import './Plan.scss'
import React, { useEffect, useState } from 'react'
import { withRouter, useLocation } from 'react-router-dom'
import { connect, useDispatch } from 'react-redux'
import { Container, Row, Col } from 'reactstrap'
import { I18n } from 'react-redux-i18n'

import moduleActions from '../../../redux/modules/actions'

import { EcommerceAPI, SmartChatEcommerceAPI } from 'api'

import CredentialsConfigModal from '../Configurations/ConsoleFAQ/TabContent/AssistantView/CredentialsConfigModal'

import ButtonChangePlan from './ButtonChangePlan'
import ManagementPaymentMethod from './ManagementPaymentMethod'
import PlanModules from './PlanModules'

const Plan = (props) => {
  const { user, modules, currentPlan } = props

  const dispatch = useDispatch()
  const location = useLocation()
  const [redirectURL, setRedirectURL] = useState(null)
  const [downloadCatalogProcess, setDownloadCatalogProcess] = useState(false)
  const [inProcess, setInProcess] = useState(false)
  const [isOpenCredentialConfigModal, setIsOpenCredentialConfigModal] = useState(false)
  const [ecommerceMessageModal, setEcommerceMessageModal] = useState('msg_plugin_ecommerce_config_credentials')
  const [isCredentialConfig, setIsCredentialConfig] = React.useState(false)
  const MsgMapperEcommerceModule = {
    pluginEcommerce: 'msg_plugin_ecommerce_config_credentials',
    smartChatEcommerce: 'msg_smart_chat_module_ecommerce_config_credentials'
  }

  useEffect(() => {
    const { search } = location
    const redirectEcommerce = new URLSearchParams(search).get('redirectEcommerce')
    const activeKey = new URLSearchParams(search).get('activeKey')
    if (redirectEcommerce) setRedirectURL(`${redirectEcommerce}?activeKey=${activeKey}`)
  }, [location])

  useEffect(() => {
    if (inProcess) {
      if (modules['pluginEcommerce'].isActive && redirectURL) props.history.push(redirectURL)
    }
    if (modules['smartChatEcommerce'].isActive && downloadCatalogProcess) EcommerceAPI.downloadCatalog().catch(console.error)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modules])

  const toggleModule = async (moduleName, checked) => {
    if (checked) {
      setInProcess(true)
      if (moduleName === 'pluginEcommerce' || moduleName === 'smartChatEcommerce') {
        setEcommerceMessageModal(MsgMapperEcommerceModule[moduleName])
        try {
          await SmartChatEcommerceAPI.checkStatusShop()
          moduleActions.add(moduleName, false)(dispatch)
          setDownloadCatalogProcess(true)
        } catch (error) {
          setIsCredentialConfig(true)
          toggleCredentialConfigModal()
        }
      } else {
        moduleActions.add(moduleName, false)(dispatch)
      }
    } else {
      moduleActions.remove(moduleName, false)(dispatch)
    }
  }

  const toggleCredentialConfigModal = () => setIsOpenCredentialConfigModal(!isOpenCredentialConfigModal)

  return (
    <div className='animated fadeIn'>
      <Container fluid className='py-5 plan-container'>
        <Row>
          <Col xs="12">
            <h1>{I18n.t('dashboard_payment-plan')}</h1>
          </Col>
        </Row>

        <Row className='mt-3'>
          <Col>
            <strong>{I18n.t('dashboard_contracted-plan')}:</strong> {I18n.t(currentPlan.label)}
          </Col>
        </Row>

        <ButtonChangePlan
          onEdit={() => props.history.push(`${props.match.url}/edit`)}
          role={user.role}
        />

        <ManagementPaymentMethod
          role={user.role}
        />

        <PlanModules
          toggleModule={toggleModule}
          modules={modules}
        />
      </Container>

      <CredentialsConfigModal
        isOpen={isOpenCredentialConfigModal}
        toggle={toggleCredentialConfigModal}
        message={ecommerceMessageModal}
        isCredentialConfig={isCredentialConfig}
      />
    </div>
  )
}

const mapStateToProps = (state) => ({
  user: state.user,
  currentPlan: state.currentPlan,
  modules: state.modules
})

export default connect(mapStateToProps)(withRouter(Plan))
